import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { path: '/', label: '首页' },
    { path: '/features', label: '产品功能' },
    { path: '/solutions', label: '解决方案' },
    { path: '/benefits', label: '核心优势' },
    { path: '/pricing', label: '价格方案' },
    { path: '/partners', label: '合作伙伴' },
    { path: '/faq', label: '常见问题' }
  ];

  const handleFreeTrial = () => {
    window.open('http://112.74.46.225:8002/admin/login?register=register', '_blank');
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm shadow-sm z-40">
      <nav className="mx-auto px-6 lg:px-12 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <Link to="/" className="flex items-center gap-3">
              <img 
                src="https://static.readdy.ai/image/f3112bc369a9d36317555af5f615a961/5a51011c24518064969eadc609a67b45.png" 
                alt="智研云 Logo" 
                className="w-10 h-10 object-contain"
              />
              <h1 className="text-2xl font-bold bg-gradient-to-r from-teal-600 to-blue-600 bg-clip-text text-transparent cursor-pointer">
                智研云
              </h1>
            </Link>
          </div>

          <div className="hidden lg:flex items-center space-x-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-4 py-2 rounded-full transition-all whitespace-nowrap cursor-pointer font-medium ${
                  location.pathname === item.path
                    ? 'text-teal-600 bg-teal-50'
                    : 'text-gray-700 hover:text-teal-600 hover:bg-teal-50'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <button
              onClick={handleFreeTrial}
              className="ml-4 bg-gradient-to-r from-teal-600 to-teal-700 text-white px-7 py-2.5 rounded-full hover:from-teal-700 hover:to-teal-800 transition-all shadow-md hover:shadow-lg hover:scale-105 whitespace-nowrap cursor-pointer font-semibold"
            >
              免费试用
            </button>
          </div>

          <button 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer rounded-full hover:bg-gray-100 transition-colors"
          >
            <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-2xl text-gray-700`}></i>
          </button>
        </div>

        {mobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 space-y-2 bg-white rounded-2xl shadow-lg p-4 border border-gray-100">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setMobileMenuOpen(false)}
                className={`block w-full text-left py-3 px-4 rounded-xl cursor-pointer whitespace-nowrap font-medium transition-all ${
                  location.pathname === item.path
                    ? 'text-teal-600 bg-teal-50'
                    : 'text-gray-700 hover:text-teal-600 hover:bg-teal-50'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <button
              onClick={() => {
                setMobileMenuOpen(false);
                handleFreeTrial();
              }}
              className="bg-gradient-to-r from-teal-600 to-teal-700 text-white px-6 py-3 rounded-xl hover:from-teal-700 hover:to-teal-800 transition-all w-full cursor-pointer whitespace-nowrap font-semibold mt-2 shadow-md block text-center"
            >
              免费试用
            </button>
          </div>
        )}
      </nav>
    </header>
  );
}
